var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("↓")]),_c('span',{staticStyle:{"--delay":"0.1s"}},[_vm._v("↓")]),_c('span',{staticStyle:{"--delay":"0.3s"}},[_vm._v("↓")]),_c('span',{staticStyle:{"--delay":"0.4s"}},[_vm._v("↓")]),_c('span',{staticStyle:{"--delay":"0.5s"}},[_vm._v("↓")])])
}]

export { render, staticRenderFns }